<!-- @veltra/icons generated sha256:546f1ab79d425b6f gen:8 source:src/svg/normal/d-arrow-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'DArrowRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m3.405 11.986.01.01a.653.653 0 0 0 .922.005l3.65-3.649a.497.497 0 0 0 0-.704l-3.65-3.65a.63.63 0 0 0-.904-.012l-.01.01a.65.65 0 0 0-.006.92L6.5 8l-3.083 3.083a.63.63 0 0 0-.012.903m5 0 .028.028c.254.254.65.241.904-.013l3.65-3.649a.497.497 0 0 0 0-.704l-3.65-3.65a.63.63 0 0 0-.914-.001.65.65 0 0 0-.006.92L11.5 8l-3.083 3.083a.63.63 0 0 0-.012.903"
    />
  </svg>
</template>
